import styles from './list.module.css';
import axios from 'axios';
import Loader from '../../components/Loader';
import { authData } from "../../components/getAuth";
import { useState } from 'react';

const CancelPopup = ({ setModalShow, setCurrentItem, shippingId, camcelItem }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);

  const onSubmitLocal = () => {
    setModalShow(false);
    setLoading(true);

    axios.delete(process.env.REACT_APP_API_URL + 'v1/shippings/' + shippingId, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {
        camcelItem(response.data.message, shippingId);
      } else {
        setLoading(false);
      }
    }).catch(error => {
      setLoading(false);
    });
  }

  return (<>
    {loading && <Loader />}
    <div className={`${styles.FullDiv}`}>
      <h2 className={`${styles.PopupTitle}`}>Sure? You want to remove this shipping?</h2>
      <div className={`${styles.FormButtonArea}`}>
        <input className={`${styles.CancelBU}`} value="No" type="button" onClick={(e) => { setModalShow(false); setCurrentItem(0); }} />
        <input className={`${styles.SubmitBU}`} value="Yes" type="button" onClick={onSubmitLocal.bind(this)} />
      </div>
    </div>
  </>)
}

export default CancelPopup;